import { Card, CountBadge, Status, formatEuro } from '@elbklar/ui';
import type { Anfrage, AnfrageStatus } from '@/lib/api';

function anfrageWert(anfrage: Anfrage): number {
  if (anfrage.value === null || anfrage.value === undefined) return 0;
  const num = typeof anfrage.value === 'string' ? parseFloat(anfrage.value) : anfrage.value;
  return Number.isNaN(num) ? 0 : num;
}

/**
 * Eine Phase der Pipeline am Handy: Status mit Zahl und Summe, darunter die
 * Anfragen als Zeilen. Nur lesen; Verschieben und Abschließen am Rechner.
 */
export function PhasenListe({
  status,
  anfragen,
  customerNames,
}: {
  status: AnfrageStatus;
  anfragen: Anfrage[];
  customerNames: Record<string, string>;
}) {
  const summe = anfragen.reduce((s, a) => s + anfrageWert(a), 0);
  return (
    <Card
      flush
      title={
        <span className="flex items-center gap-2">
          <Status status={status} />
          <CountBadge>{anfragen.length}</CountBadge>
        </span>
      }
      actions={summe > 0 ? <span className="t-mono text-muted-foreground">{formatEuro(summe)}</span> : undefined}
    >
      {anfragen.length === 0 ? (
        <p className="px-5 pb-4 t-small text-muted-foreground">Keine Anfragen</p>
      ) : (
        <ul>
          {anfragen.map((a) => {
            const kunde = customerNames[a.customer_id];
            const titel = a.kundenwunsch || a.sales_nachricht || kunde || 'Anfrage';
            const unter = [titel !== kunde ? kunde : null].filter(Boolean).join(' · ');
            return (
              <li key={a.id} className="flex min-h-row items-center gap-3 border-t border-border px-5 py-2.5">
                <div className="min-w-0 flex-1">
                  <div className="truncate font-medium">{titel}</div>
                  {(unter || a.dringlichkeit) && (
                    <div className="mt-0.5 flex min-w-0 items-center gap-2 t-small text-muted-foreground">
                      {a.dringlichkeit && a.dringlichkeit !== 'normal' && (
                        <Status status={`dringlichkeit_${a.dringlichkeit}`} variant="plain" className="shrink-0" />
                      )}
                      {unter && <span className="min-w-0 truncate">{unter}</span>}
                    </div>
                  )}
                  {a.status === 'VERLOREN' && a.lost_reason && (
                    <p className="mt-0.5 line-clamp-2 t-small text-danger">{a.lost_reason}</p>
                  )}
                </div>
                {anfrageWert(a) > 0 && <div className="shrink-0 font-mono text-[13px] tabular">{formatEuro(anfrageWert(a))}</div>}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
